import { takeEvery, call, put } from 'redux-saga/effects'
import makeAPIRequest from 'store/entities/api/sagas'
import * as REQUESTS from 'app/constants/requests'
import { FAVORITE_ACTIVITIES } from '../actionTypes'
import { FAVORITE_ACTIVITIES_PATH } from 'app/constants/api/favoriteActivity'
import { favoriteActivities } from '../actions'

export default function* favoriteActivityGetSaga() {
  yield takeEvery(FAVORITE_ACTIVITIES.GET.REQUEST, handleFavoriteActivityGet)
}

export function* handleFavoriteActivityGet() {
  try {
    const response = yield call(makeAPIRequest, FAVORITE_ACTIVITIES_PATH, {
      method: REQUESTS.GET,
    })
    const { data } = response.data
    yield put(favoriteActivities.get.success(data))
  } catch (badResponse) {
    console.log(badResponse)
    yield put(favoriteActivities.get.fail(badResponse))
  }
}
